import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  isActive?: boolean;
}

const LogoutIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  isActive = false,
  ...props
}) => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.50208 0.52737C7.63769 0.504794 7.77649 0.510422 7.90983 0.5439C8.04316 0.577379 8.16816 0.637991 8.27702 0.721949C8.38588 0.805907 8.47626 0.911409 8.54251 1.03186C8.60876 1.15232 8.64947 1.28514 8.66208 1.42204L8.66675 1.51404V2.33337H10.0001C10.3365 2.33326 10.6605 2.46031 10.9071 2.68903C11.1538 2.91776 11.3049 3.23127 11.3301 3.5667L11.3334 3.6667V10.3334C11.3334 10.6696 11.2062 10.9935 10.9775 11.24C10.7488 11.4865 10.4354 11.6375 10.1001 11.6627L10.0001 11.6667H8.66675V12.4867C8.66666 12.6242 8.63824 12.7601 8.58326 12.8861C8.52828 13.012 8.44792 13.1253 8.3472 13.2189C8.24648 13.3124 8.12756 13.3841 7.99787 13.4297C7.86817 13.4752 7.73049 13.4935 7.59341 13.4834L7.50208 13.4727L1.78075 12.5194C1.48755 12.4705 1.21908 12.3252 1.01797 12.1063C0.816862 11.8874 0.69465 11.6076 0.670748 11.3114L0.666748 11.204V2.79604C0.666719 2.49889 0.765951 2.21024 0.948692 1.97593C1.13143 1.74162 1.38721 1.57506 1.67541 1.5027L1.78075 1.4807L7.50208 0.52737ZM7.33341 1.90737L2.00008 2.79604V11.204L7.33341 12.0927V1.90737ZM10.0001 3.6667H8.66675V10.3334H10.0001V3.6667ZM5.66675 6.00004C5.93196 6.00004 6.18632 6.10539 6.37385 6.29293C6.56139 6.48047 6.66675 6.73482 6.66675 7.00004C6.66675 7.26525 6.56139 7.51961 6.37385 7.70714C6.18632 7.89468 5.93196 8.00004 5.66675 8.00004C5.40153 8.00004 5.14718 7.89468 4.95964 7.70714C4.7721 7.51961 4.66675 7.26525 4.66675 7.00004C4.66675 6.73482 4.7721 6.48047 4.95964 6.29293C5.14718 6.10539 5.40153 6.00004 5.66675 6.00004Z"
        fill="#FF5249"
      />
    </svg>
  );
};

export default LogoutIcon;
